/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, CoordinatesFromJSON, CoordinatesToJSON, DateSlotFromJSON, DateSlotToJSON, DaySlotFromJSON, DaySlotToJSON, } from './';
export function PickupLocationFromJSON(json) {
    return PickupLocationFromJSONTyped(json, false);
}
export function PickupLocationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'price': json['price'],
        'slots': (json['slots'].map(DateSlotFromJSON)),
        'name': json['name'],
        'address': AddressFromJSON(json['address']),
        'coordinates': CoordinatesFromJSON(json['coordinates']),
        'openingHours': !exists(json, 'openingHours') ? undefined : (json['openingHours'].map(DaySlotFromJSON)),
    };
}
export function PickupLocationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'price': value.price,
        'slots': (value.slots.map(DateSlotToJSON)),
        'name': value.name,
        'address': AddressToJSON(value.address),
        'coordinates': CoordinatesToJSON(value.coordinates),
        'openingHours': value.openingHours === undefined ? undefined : (value.openingHours.map(DaySlotToJSON)),
    };
}
